import type { IPathBaseParam } from "./path";
import type { IUserMeVerifyEmailCompleteDto } from "./types";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IUserMeVerifyEmailCompleteDto
>("users.me.verifyUserEmail.complete");

export const complete = {
  ...postApis,
};
